import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Box, Paper, Stack } from '@mui/material';
import styles from './PublicLayout.module.scss';
import { routes } from '../../../config/routes/routes';
import { colors } from '../../styles/colors';
import logo from '../../../assets/logo.png';
import overlay from '../../../assets/overlay.jpg';

export const PublicLayout = () => {
  return (
    <Box className={styles.publicLayoutContainer}>
      <Stack component="main" className={styles.mainContainer}>
        <Stack className={styles.authInnerPart}>
          <Box>
            <Link
              to={routes.homepage}
              className={styles.logoMainLink}
              style={{ color: colors.buttonContainedPrimaryColor }}
            >
              <Box className={styles.logoLink}>
                <img src={logo} />
              </Box>
            </Link>
            <Paper
              elevation={0}
              className={styles.outletContainer}
              style={{ backgroundColor: colors.backgroundColor }}
            >
              <Outlet />
            </Paper>
          </Box>
        </Stack>
        <Stack className={styles.mainImageContainer}>
          <img src={overlay} />
        </Stack>
      </Stack>
    </Box>
  );
};

export default PublicLayout;
